export const PRIORITY_THEME = {
  critical: { bg: "#fee2e2", border: "#fecaca", fg: "#991b1b", label: "Critical" },
  high: { bg: "#fef3c7", border: "#fde68a", fg: "#92400e", label: "High" },
  normal: { bg: "#dbeafe", border: "#bfdbfe", fg: "#1e40af", label: "Normal" },
  low: { bg: "#f3f4f6", border: "#e5e7eb", fg: "#4b5563", label: "Low" },
};

export function formatNoticeLocal(iso) {
  if (!iso) return "—";
  return new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZoneName: "short",
  }).format(new Date(iso));
}
